// Module
var code = "<div class=\"toggle-all\"> <a ng-click=\"handleShowHide()\" class=\"btn btn-ccs-border-btn\"> Show/Hide Completed Trainings </a> </div> ";
// Exports
module.exports = code;